
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/friends",
      function () {
        return require("private-next-pages/friends.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/friends"])
      });
    }
  